import { Component, inject } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatIcon } from '@angular/material/icon';
import { UserProfileMenuComponent } from '../../user-profile-menu/user-profile-menu.component';

@Component({
	selector: 'app-profile-menu-bottom-sheet',
	templateUrl: './user-profile-menu-bottom-sheet.component.html',
	styleUrls: ['./user-profile-menu-bottom-sheet.component.scss'],
	standalone: true,
	imports: [MatIcon, UserProfileMenuComponent],
})
export class ProfileMenuBottomSheetComponent {
	private readonly bottomSheetRef = inject(MatBottomSheetRef<ProfileMenuBottomSheetComponent>);

	public closeSheet(): void {
		this.bottomSheetRef.dismiss();
	}
}
